<template>
  <div class="flex flex-col gap-3 rounded-2xl border border-untitled-gray-200 bg-white p-4 sm:p-5 shadow-sm">
    <div class="flex items-center gap-2.5">
      <span
        class="h-6 w-1.5 rounded-full"
        style="background: linear-gradient(180deg, #119381, #01A9B7);"
      ></span>
      <h2 class="text-base font-semibold text-untitled-gray-900">
        All Available Content
      </h2>
    </div>

    <!-- Filters -->
    <V4AllAvailableContentFilter />
    <!-- end filters -->

    <div class="w-full">
      <Transition name="slide-fade" mode="out-in">
        <KeepAlive>
          <component :is="display" />
        </KeepAlive>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { computed, onMounted, watch, defineOptions } from "vue";
import { defineAsyncComponent } from "vue";
import { useHomeAvailableContentStore } from "@/stores/home/useHomeAllAvailableContent.store";
import { useEnrolledCourseStore } from "@/stores/enrolledCourseStore";
import eventBus from "@/plugins/eventBus";
import V4AllAvailableContentFilter from "./filter/V4AllAvailableContentFilter.vue";

defineOptions({
  inheritAttrs: false,
});

const GridCourses = defineAsyncComponent(() =>
  import("./V4AvailableContentGrid.vue")
);
const allAvailableContentStore = useHomeAvailableContentStore();
const enrolledCourseStore = useEnrolledCourseStore();
const { selectedFilter } = storeToRefs(enrolledCourseStore);
const { page, contents, isLoadMore } = storeToRefs(allAvailableContentStore);

const display = computed(() => {
  return GridCourses;
});

const handleFetchContents = async () => {
  await allAvailableContentStore.handleFetchContents(false, true);
  eventBus.$emit("show-right-section");
};

onMounted(() => {
  if (!contents.value.length) {
    handleFetchContents();
  } else {
    eventBus.$emit("show-right-section");
  }
});

watch(selectedFilter, () => {
  contents.value = [];
  page.value = 1;
  isLoadMore.value = true;
  handleFetchContents();
});

watch(page, () => {
  handleFetchContents();
});
</script>

<style lang="css" scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
